import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {CourseSearchModel} from "../course-search.model";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-course-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(CourseSingleSelectEditControlComponent),
        provideSearchModel(CourseSearchModel)
    ]
})
export class CourseSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<CourseSearchModel> {
    private _courseDefinitionId: number;

    constructor(model: CourseSearchModel, injector: Injector) {
        super(model, injector, "courseId", "name");
    }

    get courseDefinitionId(): number {
        return this._courseDefinitionId;
    }

    @Input()
    set courseDefinitionId(value: number) {
        const searchRequired: boolean = this._courseDefinitionId !== value;
        this._courseDefinitionId = value;
        if (searchRequired) {
            this.model.filter["courseDefinitionId"] = value;
            this.loadDataFromSearchModel();
        }
    }
}
